import React from "react";
import { FiStar, FiCheckCircle } from "react-icons/fi";

interface ProgramFeedbackRatingProps {
  rating: number;
  submittedAt?: string;
  compact?: boolean;
  className?: string;
}

const ProgramFeedbackRating: React.FC<ProgramFeedbackRatingProps> = ({
  rating,
  submittedAt,
  compact = false,
  className = ""
}) => {
  const renderStars = () => {
    return Array.from({ length: 5 }, (_, index) => {
      const starNumber = index + 1;
      const isFilled = starNumber <= rating;
      
      return (
        <FiStar
          key={index}
          className={`${compact ? 'w-4 h-4' : 'w-5 h-5'} ${
            isFilled ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'
          }`}
        />
      );
    });
  };

  if (compact) {
    // Compact version for program cards
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        <div className="flex items-center gap-1">
          {renderStars()}
        </div>
        <span className="text-sm font-medium text-gray-700">{rating.toFixed(1)}</span>
        <FiCheckCircle className="w-4 h-4 text-green-600" />
      </div>
    );
  }

  // Full version for program page sidebar
  return (
    <div className={`bg-white rounded-xl border border-gray-200 p-6 shadow-sm ${className}`}>
      <div className="flex items-center gap-2 mb-4">
        <FiCheckCircle className="w-5 h-5 text-green-600" />
        <h3 className="text-lg font-semibold text-gray-900">Your Feedback</h3>
      </div>
      
      <div className="space-y-4">
        <div>
          <p className="text-sm text-gray-600 mb-2">Program Rating</p>
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1">
              {renderStars()}
            </div>
            <span className="text-2xl font-bold text-gray-900">{rating.toFixed(1)}</span>
          </div>
        </div>
        
        {submittedAt && (
          <div className="pt-4 border-t border-gray-100">
            <p className="text-xs text-gray-500">
              Submitted on {new Date(submittedAt).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgramFeedbackRating;

